import React from 'react';
import Image from 'react-bootstrap/Image';
import phoneIcon from '../../../images/telephone-call.png';

function PhoneImage() {
    
    return  <Image src={phoneIcon} fluid alt="telefon-ikon"/>;
    
}
export default PhoneImage;